import React from "react";

import { useNavigate, useTranslation } from "utils";

import { COUNTRY_CODE } from "consts";

import { Button, Flex, LazyLoadImage, Modal, Typography, WidgetVideo } from "components";

import { HISTORICAL_PRACTICE_EXPLAINER_VIDEO_VIMEO_URL } from "pages/app/historical-practice-data-table-view/HistoricalPracticeDataTableView";

export const DataTableViewOnboardingModal = ({
  isOpen,
  setIsOpen,
  onComplete,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onComplete?: () => void | Promise<void>;
}) => {
  const { t } = useTranslation("historicalPracticeDataTableView");
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/all-fields", { state: { openTasksDrawer: true } });
  };

  const handleNext = async () => {
    await onComplete?.();
    setIsOpen(false);
  };

  return (
    <Modal
      className="historical-practice-data-table-view-onboarding-modal"
      open={isOpen}
      onCancel={() => setIsOpen(false)}
      footer={<ModalFooter handleBack={handleBack} handleNext={handleNext} />}
      content={
        <Flex vertical justify="center" align="center" gap="2rem" className="historical-practice-data-table-view-onboarding-modal-container">
          <LazyLoadImage src="/images/misc/illustration-data-gap-flow.webp" alt="data gap flow illustration" width="282" height="177" />
          <Flex vertical gap="0.5rem">
            <Typography variant="h1" className="historical-practice-data-table-view-onboarding-modal-title">
              {t("onboardingModal.intro.title")}
            </Typography>
            <Typography variant="paragraph-m" className="historical-practice-data-table-view-onboarding-modal-description">
              {t("onboardingModal.intro.description")}
            </Typography>
          </Flex>
          <WidgetVideo
            vimeoUrlOrId={HISTORICAL_PRACTICE_EXPLAINER_VIDEO_VIMEO_URL}
            title={t("onboardingModal.intro.videoSection.title")}
            description={t("onboardingModal.intro.videoSection.description")}
            allowedCountries={[COUNTRY_CODE.GERMANY]}
          />
        </Flex>
      }
    />
  );
};

const ModalFooter = ({ handleBack, handleNext }: { handleBack: () => void; handleNext: () => void }) => {
  const { t } = useTranslation("historicalPracticeDataTableView");

  return (
    <Flex justify="space-between" align="center" gap="1rem" style={{ width: "100%" }}>
      <Button type="text" size="small" onClick={handleBack}>
        {t("onboardingModal.cta.back")}
      </Button>
      <Button type="primary" size="small" onClick={handleNext} style={{ maxWidth: "min-content" }}>
        {t("onboardingModal.cta.getStarted")}
      </Button>
    </Flex>
  );
};
